import { render } from "./complaint_list.vue?vue&type=template&id=c17b26b2"
import script from "./complaint_list.vue?vue&type=script&lang=js"
export * from "./complaint_list.vue?vue&type=script&lang=js"

import "./complaint_list.vue?vue&type=style&index=0&id=c17b26b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__